export type UserRole = 'admin' | 'staff';

export type Permission = string;

/** Route → permission mapping (permission codes come from backend). */
export const ROUTE_PERMISSIONS: { path: string; permission: string }[] = [
  { path: '/reports/gst-filing', permission: 'gst-filing.view' },
  { path: '/reports', permission: 'reports.view' },
  { path: '/dashboard', permission: 'dashboard.view' },
  { path: '/billing', permission: 'billing.access' },
  { path: '/pos', permission: 'billing.access' },
  { path: '/orders', permission: 'orders.access' },
  { path: '/customers', permission: 'customers.access' },
  { path: '/products', permission: 'products.view' },
  { path: '/categories', permission: 'categories.manage' },
  { path: '/purchase', permission: 'purchase.access' },
  { path: '/purchases', permission: 'purchases.access' },
  { path: '/vendors', permission: 'vendors.manage' },
  { path: '/units', permission: 'units.manage' },
  { path: '/expenses', permission: 'expenses.manage' },
  { path: '/transactions', permission: 'customers.access' },
  { path: '/settings', permission: 'settings.manage' },
  { path: '/printer-settings', permission: 'printer.manage' },
  { path: '/users', permission: 'users.manage' },
];

export const DEFAULT_ROUTE_BY_ROLE: Record<UserRole, string> = {
  admin: '/dashboard',
  staff: '/billing',
};

export interface NavItem {
  route: string;
  label: string;
  permission: string;
  icon: string;
  section?: 'main' | 'settings';
}

export const NAV_ITEMS: NavItem[] = [
  { route: '/dashboard', label: 'Dashboard', permission: 'dashboard.view', icon: 'dashboard', section: 'main' },
  { route: '/billing', label: 'Billing', permission: 'billing.access', icon: 'billing', section: 'main' },
  { route: '/orders', label: 'Orders', permission: 'orders.access', icon: 'orders', section: 'main' },
  { route: '/customers', label: 'Customers', permission: 'customers.access', icon: 'customers', section: 'main' },
  { route: '/products', label: 'Products', permission: 'products.view', icon: 'products', section: 'main' },
  { route: '/categories', label: 'Categories', permission: 'categories.manage', icon: 'categories', section: 'main' },
  { route: '/reports', label: 'Reports', permission: 'reports.view', icon: 'reports', section: 'main' },
  { route: '/reports/gst-filing', label: 'GST Filing Report', permission: 'gst-filing.view', icon: 'gst-filing', section: 'main' },
  { route: '/purchase', label: 'Purchase', permission: 'purchase.access', icon: 'purchase', section: 'main' },
  { route: '/purchases', label: 'Purchase Orders', permission: 'purchases.access', icon: 'purchases', section: 'main' },
  { route: '/vendors', label: 'Vendors', permission: 'vendors.manage', icon: 'vendors', section: 'main' },
  { route: '/units', label: 'Unit Types', permission: 'units.manage', icon: 'units', section: 'main' },
  { route: '/expenses', label: 'Expenses', permission: 'expenses.manage', icon: 'expenses', section: 'main' },
  { route: '/settings', label: 'Company Settings', permission: 'settings.manage', icon: 'settings', section: 'settings' },
  { route: '/printer-settings', label: 'Printer Settings', permission: 'printer.manage', icon: 'printer', section: 'settings' },
  { route: '/users', label: 'Users & Roles', permission: 'users.manage', icon: 'users', section: 'settings' },
];
